'use strict';

var $ = require('jquery');
var WorldMap = require('./WorldMap.js');
var DiversityChart = require('./ChartFromStats.js');

var wrapper = document.querySelector('body.__byTheNumbers');

function init() {
	if (!wrapper) {
		return;
	}
	/* Diversity Chart */
	var diversityData = document.querySelectorAll('.diversity__breakdown .dataEl');
	DiversityChart.init(diversityData, 'Ethnicity', 'Percentage');

	/* Diversity Chart */
	WorldMap.init();

	/* Hide/show content */
	var triggers = new ToggledItems;
}

function ToggledItems() {
	var _this = this;
	this.triggerEl = document.querySelectorAll('a.learnMore');
	for (var i = 0, l = this.triggerEl.length; i < l; i++) {
		var element = this.triggerEl[i];
		var href = element.getAttribute('href');
		var relatedId = href.substring(href.lastIndexOf('#') + 1);
		var targetEl = document.getElementById(relatedId);
		targetEl.classList.add('toggled');
		element.addEventListener('click', this.clickHandler.bind(this));
	}
}
ToggledItems.prototype.clickHandler = function (event) {
	event.preventDefault();
	var href = event.currentTarget.getAttribute('href');
	var relatedId = href.substring(href.lastIndexOf('#') + 1);
	this.toggleTarget(relatedId);
	this.toggleTrigger(event.currentTarget);
}
ToggledItems.prototype.toggleTarget = function (relatedId) {
	var targetEl = document.getElementById(relatedId);
	targetEl.classList.toggle('toggled');
};
ToggledItems.prototype.toggleTrigger = function (targetEl) {
	targetEl.classList.toggle('triggered');
};
module.exports = {
	init: init
}